import React, { useEffect, useState } from 'react';
import './MainInsuranceForm.scss';
import useTitle from "../../Hooks/useTitle";
import InsuranceStep from "./InsuranceStep/InsuranceStep";
import DynaButton from "../DynaView/DynaButton";
import { useNavigate } from "react-router-dom";
import InsuranceTypeStep from "./InsuranceStepsForm/InsuranceTypeStep";
import ChoosePersonStep from "./InsuranceStepsForm/ChoosePersonStep/ChoosePersonStep";
import InsuranceInformationStep from "./InsuranceStepsForm/InsuranceInformationStep";
import InsurancePaymentStep from "./InsuranceStepsForm/InsurancePaymentStep";
import InternalResourcesStep from "./InsuranceStepsForm/InternalResourcesStep";
import FinalStep from "./InsuranceStepsForm/FinalStep";
import Loader from "../../Loader";
import {
  AddLegalPerson, AddRealOrganizePerson, AddRealPerson, CheckInsurancePrice, CustomerInsurancePrice,
  getInsuranceTypeData, GoLastPage, insuranceLastNumber, SubmitInsurance
} from "./InsuranceRequests";
import { toast } from "react-toastify";
import ConfirmInformationStep from "./InsuranceStepsForm/ConfirmInformationStep";
import UtilsFunctions from "../../../utils/UtilsFunctions";
import numeric from "../../../utils/NumericFunction";

const MainInsuranceForm = () => {

  useTitle("صدور بیمه نامه");
  const navigateTo = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = new Date().toLocaleDateString("fa-IR", options);
  const [insuranceStep, setInsuranceStep] = useState(1);
  const [insuranceType, setInsuranceType] = useState([]);
  const [paymentType, setPaymentType] = useState("bank"); // نوع واریز وجه
  const [paymentAmount, setPaymentAmount] = useState("0"); // مقدار مبلغ واریزی
  const [sendData, setSendData] = useState({
    typeId: "",
    typeSubId: "",
    typeName: "",
    personType: "real",
    nationalId: "",
    personId: "",
    organizationName: "",
    mobileNumber: "",
    telephone: "",
    economicCode: "",
    personName: "",
    address: "",
    fullName: "",
    postalCode: "",
    organizationId: "",
    personnelNumber: "",
    insuranceLastNumber: "",
    insuranceNumberYear: "",
    dateOfIssue: numeric.p2e(todayDate),
    plate: "",
    insurancePrice: "0",
    firstInternalDate: "",
    prePayment: "0",
    countInsurance: "1",
    eachInternalPrice: "0",
    customerInsurancePrice: "",
    customerOfferPrice: "0",
    customerPrePayment: "",
    customerFirstInternalDate: "",
    customerCountInsurance: 1,
    customerPay: "",
    hasAgent: false,
    agentId: "",
    receiveType: "default",
    bankId: "",
    partOne: "",
    partTwo: "",
    partThree: "الف",
    partFour: "",
    partFive: "",
    partSix: "",
    partSeven: "",
    partEight: "",
    installmentDetails: [],
    customerInstallmentDetails: [],
    customerInstallmentDetailsTotal: 0,
    customerPrePaymentPayType: "cash",
    payType: "اقساط",
    customerBankId: "",
    customerFundId: "",
    insuranceNumber: "",
    plateType: "car",
    customerBankPrice: "",
    customerFundPrice: "",
    customerReceivedPay: "",
    customerRealPay: "",
  });

  const GoToInsurancePrint = (id) => {
    navigateTo("/insurance-print",
      { state: { insuranceId: id } });
  }

  useEffect(() => {
    void getInsuranceTypeData(setInsuranceType, setIsLoad)
  }, []);


  const insuranceForwardStep = () => {
    if (insuranceStep === 1) {
      if (sendData?.typeId !== "") {
        setInsuranceStep(insuranceStep + 1)
      } else {
        toast.error("نوع بیمه را انتخاب کنید")
      }
    } else if (insuranceStep === 2) {
      if (sendData?.personId !== "") {
        setInsuranceStep(insuranceStep + 1)
      } else {
        if (sendData?.personType === "legal") {
          void AddLegalPerson(sendData, setSendData, setInsuranceStep)
        } else if (sendData?.personType === "real") {
          void AddRealPerson(sendData, setSendData, setInsuranceStep)
        } else if (sendData?.personType === "real-organize") {
          void AddRealOrganizePerson(sendData, setSendData, setInsuranceStep)
        }
      }
    } else if (insuranceStep === 3) {
      void insuranceLastNumber(sendData, setInsuranceStep)
    } else if (insuranceStep === 4) {
      void CheckInsurancePrice(sendData, setInsuranceStep)
    } else if (insuranceStep === 5) {
      void CustomerInsurancePrice(sendData, setInsuranceStep)
    } else if (insuranceStep === 6) {
      void GoLastPage(sendData, setInsuranceStep, paymentType)
    } else {
      void SubmitInsurance(sendData, setSendData, setInsuranceStep, GoToInsurancePrint)
    }
  }

  const insuranceBackStep = () => {
    if (insuranceStep === 1) {
      navigateTo(-1)
    } else {
      if (sendData.payType === "نقدی" && insuranceStep === 6) {
        setInsuranceStep(insuranceStep - 2);
      } else {
        setInsuranceStep(insuranceStep - 1);
      }
    }
  }

  try {
    return (
      <section className={"main-insurance-form"}>
        {isLoad ? <>
          <InsuranceStep insuranceStep={insuranceStep} />
          <div className={"content-form"}>
            {insuranceStep === 1 ?
              <InsuranceTypeStep insuranceType={insuranceType} sendData={sendData} setSendData={setSendData} /> :
              insuranceStep === 2 ?
                <ChoosePersonStep sendData={sendData} setSendData={setSendData} /> :
                insuranceStep === 3 ?
                  <InsuranceInformationStep sendData={sendData} setSendData={setSendData} /> :
                  insuranceStep === 4 ?
                    <InsurancePaymentStep sendData={sendData} setSendData={setSendData} paymentAmount={paymentAmount} setPaymentAmount={setPaymentAmount} /> :
                    insuranceStep === 5 ?
                      <InternalResourcesStep sendData={sendData} setSendData={setSendData} /> :
                      insuranceStep === 6 ?
                        <FinalStep sendData={sendData} setSendData={setSendData} paymentType={paymentType} setPaymentType={setPaymentType} paymentAmount={paymentAmount} /> :
                        insuranceStep === 7 ? <ConfirmInformationStep sendData={sendData} /> :
                          <>not found</>
            }
          </div>
          <div className={"row-button"}>
            <DynaButton className={"insurance-button-cansel"}
              type={"button"}
              onClick={insuranceBackStep}>{insuranceStep === 1 ? "انصراف" : "مرحله قبل"}</DynaButton>
            <DynaButton
              className={"insurance-button"}
              type={"button"}
              onClick={insuranceForwardStep}
            >
              {insuranceStep === 7
                ? (sendData.payType === "اقساط" ? "ثبت و پرینت" : "ثبت")
                : "مرحله بعد"}
            </DynaButton>

          </div>
        </> : <Loader />}
      </section>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default React.memo(MainInsuranceForm);